import {CommonMessages} from '../common.messages';

export const PanelReportsReferralPayoutsMessages = {
    ExportReportFailed: {
        key: 'ExportReportFailed',
        message: 'Error while communication with the server. Unable to export report.'
    },
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while communication with the server. Unable to get the Payout Requests report.'
    },
    GetFilterControlsFailed: {
        key: 'GetFilterControlsFailed',
        message: 'Error while communication with the server. Unable to build the report filters.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    MissingDateRange: {
        key: 'MissingDateRange',
        message: 'Date From and Date To must be selected together.'
    },
    ...CommonMessages
};
